module.exports = __webpack_public_path__ + "media/theme/tutorial__mobage--4--redeem-39a48c4f.png";